<template>
    <v-img
        :src="`${CDN_IMG_URL}/drop.png`"
        :lazy-src="`${CDN_IMG_URL}/drop.png`"
        class="fill-height"
        cover
        center
        height="100vh"
    >
        <v-container class="fill-height">
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="5">
                    <v-card class="primary--border bg-card-color-opacity">
                        <v-card-text>
                            <nuxt-link hreflang="en" to="/">
                                <v-img
                                    :src="`${CDN_IMG_URL}/website-logo.webp`"
                                    :lazy-src="`${CDN_IMG_URL}/website-logo.webp`"
                                    max-width="100%"
                                    height="75"
                                    contain
                                    alt="logo"
                                    class="mb-4"
                                ></v-img>
                            </nuxt-link>
                            <v-form
                                v-if="step == 'forgotPassword'"
                                ref="form"
                                v-model="valid"
                                :lazy-validation="lazy"
                            >
                                <v-card-text
                                    class="text-center body-1 white--text"
                                    >Please enter your Email / Mobile
                                    Number.</v-card-text
                                >
                                <!-- <v-text-field
                  v-model.trim="form.userName"
                  label="Email"
                  type="email"
                  prepend-icon="mdi-email"
                  :rules="rules.email"
                  required
                  class="form-input"
                  onkeypress="return !/[`~!# $%^&*()+\=\[\]{};':\\|,<>\/?]+/.test(event.key)"
                ></v-text-field> -->
                                <div class="d-flex align-center">
                                    <!-- <vue-country-code
                    class="black--text mr-2"
                    :preferred-countries="['in', 'ae', 'us']"
                    style="height: 32px"
                    @onSelect="onSelect"
                  >
                  </vue-country-code> -->

                                    <!-- <country-code
                    v-model="confirmForm.countryCode"
                    class="mr-2 mt-n1 flex-grow-0"
                    @input="onSelect"
                    :readonly="BDcheck"
                  />

                  <v-text-field
                    v-model="form.mobileNo"
                    label="Mobile Number"
                    counter
                    type="number"
                    maxlength="10"
                    :rules="rules.contact"
                    required
                    onkeypress="return !/[ e]+/.test(event.key)"
                  ></v-text-field> -->

                                    <country-code
                                        v-model="confirmForm.countryCode"
                                        class="mr-2 mt-n1 flex-grow-0"
                                        :readonly="BDcheck"
                                    />
                                    <v-text-field
                                        v-model.trim="form.userName"
                                        :prefix="
                                            version &&
                                            version.projectCode !== 'bd'
                                                ? ''
                                                : '0'
                                        "
                                        label="Email / Mobile Number"
                                        type="text"
                                        required
                                        :rules="rules.userName"
                                        class="form-input line-height"
                                    ></v-text-field>
                                </div>
                                <!-- label="Email Or Mobile No." -->
                                <!-- hint="Eg. example@email.com Or +91 9876543210" -->
                                <v-btn
                                    :loading="loading"
                                    rounded
                                    block
                                    :disabled="!valid"
                                    color="primary"
                                    class="mt-8"
                                    @click="forgotPassword()"
                                >
                                    Forgot Password
                                </v-btn>
                            </v-form>

                            <v-form
                                v-else
                                ref="confirmForgotForm"
                                v-model="valid"
                                :lazy-validation="lazy"
                            >
                                <!-- <v-text-field
                  v-model="confirmForm.userName"
                  label="Email"
                  type="email"
                  prepend-icon="mdi-email"
                  disabled
                  required
                ></v-text-field> -->
                                <!-- <v-text-field
                  v-model="confirmForm.mobileNo"
                  label="Mobile Number"
                  type="text"
                  prepend-icon="mdi-cellphone"
                  disabled
                  required
                ></v-text-field> -->
                                <v-text-field
                                    v-model.trim="confirmForm.userName"
                                    label="Email / Mobile Number"
                                    :prefix="
                                        version && version.projectCode !== 'bd'
                                            ? ''
                                            : '0'
                                    "
                                    type="text"
                                    disabled
                                    prepend-icon="mdi-cellphone"
                                    required
                                ></v-text-field>
                                <!-- label="Mobile No. or Email" -->
                                <v-text-field
                                    v-if="verifySms"
                                    v-model="confirmForm.code"
                                    prepend-icon="mdi-cellphone-key"
                                    label="Code"
                                    :rules="confirmFormRules.code"
                                    required
                                    :maxlength="6"
                                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                                ></v-text-field>
                                <v-text-field
                                    v-model="confirmForm.newPassword"
                                    prepend-icon="mdi-lock"
                                    :append-icon="
                                        showPassword ? 'mdi-eye-off' : 'mdi-eye'
                                    "
                                    :type="showPassword ? 'text' : 'password'"
                                    :rules="
                                        version &&
                                        version.projectCode &&
                                        version.projectCode === 'bd'
                                            ? confirmFormRules.bdpassword
                                            : confirmFormRules.password
                                    "
                                    label="New Password"
                                    :maxLength="
                                        version &&
                                        version.projectCode &&
                                        version.projectCode === 'bd'
                                            ? '6'
                                            : '10'
                                    "
                                    required
                                    @input="isPasswordStrong"
                                    @focus="showPwdRules = true"
                                    @blur="showPwdRules = false"
                                    @click:append="showPassword = !showPassword"
                                ></v-text-field>
                                <span class="sms-not-valid">
                                    {{ smsNotValid }}
                                </span>
                                <div
                                    v-if="!isPasswordStrongFlag"
                                    class="v-messages theme--dark error--text"
                                    role="alert"
                                >
                                    <div class="v-messages__wrapper">
                                        <div
                                            class="v-messages__message pl-left"
                                        >
                                            Oops, this is one of the easy
                                            passwords to get hacked! Please use
                                            a combination of numbers, alphabets
                                            and signs.
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="
                                        showPwdRules &&
                                        version &&
                                        version.projectCode &&
                                        version.projectCode !== 'bd'
                                    "
                                    class="v-messages"
                                    role="alert"
                                >
                                    <div class="v-messages__wrapper">
                                        <div
                                            class="v-messages__message pl-left"
                                        >
                                            <ul>
                                                <li>
                                                    Password must be min of 6
                                                    characters and max of 10.
                                                </li>
                                                <li>
                                                    Password must contain An
                                                    upper case, a lower case,
                                                    and a number.
                                                </li>
                                                <li>
                                                    The password is case
                                                    sensitive,please ensure your
                                                    caps lock is turned off.
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <v-text-field
                                    v-model="confirmForm.confirmPassword"
                                    prepend-icon="mdi-lock"
                                    :append-icon="
                                        showPassword1
                                            ? 'mdi-eye-off'
                                            : 'mdi-eye'
                                    "
                                    :type="showPassword1 ? 'text' : 'password'"
                                    label="Confirm Password*"
                                    required
                                    :max-length="
                                        version &&
                                        version.projectCode &&
                                        version.projectCode === 'bd'
                                            ? '6'
                                            : '10'
                                    "
                                    :rules="
                                        confirmFormRules.confirmPassword.concat(
                                            confirmPasswordRule
                                        )
                                    "
                                    @click:append="
                                        showPassword1 = !showPassword1
                                    "
                                ></v-text-field>
                                <!-- :rules="rules.email" -->
                                <v-btn
                                    id="confirmBtn"
                                    :loading="loading"
                                    rounded
                                    block
                                    :disabled="!valid"
                                    color="primary"
                                    class="mt-8"
                                    @click="changePassword()"
                                >
                                    Change Password
                                </v-btn>
                            </v-form>
                        </v-card-text>
                        <v-card-text
                            v-if="step == 'forgotPassword' && setUp !== 'fps'"
                            class="pa-0 mb-4 text-center"
                        >
                            Not a member?
                            <v-btn
                                v-if="
                                    !$auth.loggedIn &&
                                    version &&
                                    version.projectCode &&
                                    (version.projectCode === 'bd-new' ||
                                        version.projectCode === 'gb') &&
                                    getWhatsappData &&
                                    getWhatsappData.isRegisterBtnOnOff
                                "
                                :to="
                                    getWhatsappData.linkPage
                                        ? getWhatsappData.registerBtnLink
                                        : ''
                                "
                                :href="
                                    !getWhatsappData.linkPage
                                        ? getWhatsappData.registerBtnLink
                                        : ''
                                "
                                :target="
                                    !getWhatsappData.linkPage ? '_blank' : ''
                                "
                                color="primary"
                                class="ml-1"
                                >Register
                            </v-btn>
                        </v-card-text>
                        <v-card-text
                            v-else-if="verifySms && setUp !== 'fps'"
                            class="pa-0 my-2 text-center"
                        >
                            <v-btn
                                color="primary"
                                text
                                :disabled="timerCheck"
                                @click="resendCode()"
                            >
                                <span v-if="timerCheck">
                                    <v-icon>mdi-clock-outline</v-icon> Resend
                                    after {{ countDown }}
                                    <span class="text-capitalize">sec</span>
                                </span>
                                <span v-else>Resend Code</span></v-btn
                            >
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-img>
</template>
<script>
import { mapState } from "vuex"
import CountryCode from "@/components/fairplay/countryCode"
import constants from "../constant"
export default {
    components: { CountryCode },
    layout: "empty",
    data: () => ({
        countDown: constants.resendcodeSec,
        verifySms: constants.verifySms,
        verifyStandardOTP: constants.verifyStandardOTP,
        setUp: process.env.setUp,
        timerCheck: false,
        loading: false,
        showPwdRules: false,
        isPasswordStrongFlag: true,
        valid: true,
        step: "forgotPassword",
        showPassword: false,
        showPassword1: false,
        BDcheck: false,
        form: { userName: "", countryCode: "91" },
        confirmForm: {
            // mobileNo: '',
            userName: "",
            code: "",
            newPassword: "",
            confirmPassword: "",
            countryCode: "91"
        },
        smsNotValid: "",
        confirmFormRules: {
            code: [
                (v) => !!v || "Please check your mobile number for OTP",
                (v) => !(v.length < 6) || "OTP must be 6 digits"
            ],
            password: [
                (v) => !!v || "Password is required",
                (v) =>
                    !(v.length < 6) ||
                    "Password must be of 6 characters or more",
                (v) =>
                    !(v.split(" ").join("").length < v.length) ||
                    "Password cannot contain spaces!"
            ],
            bdpassword: [
                (v) => !!v || "Password is required",
                (v) => !(v.length < 6) || "Password must be of 6 characters",
                (v) =>
                    !(v.split(" ").join("").length < v.length) ||
                    "Password cannot contain spaces!"
            ],
            confirmPassword: [
                (v) => !!v || "Confirm Password is required",
                (v) =>
                    !(v.split(" ").join("").length < v.length) ||
                    "Password cannot contain spaces!"
            ]
        },
        rules: {
            userName: [
                (v) => !!v || "Email / Mobile Number is required",
                (v) =>
                    !(v && v.length < 5) ||
                    "Username must be of 5 characters or more"
                // (v) =>
                //   /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/.test(v) ||
                //   !(v && !/^[0-9]{8,10}$/.test(v))
            ],
            email: [
                (v) => !!v || "Email is required",
                (v) => /.+@.+\..+/.test(v) || "Invalid Email Address"
            ],
            contact: [
                (v) => !!v || "Mobile number is required",
                (v) =>
                    !(v && !/^[0-9]{10}$/.test(v)) || "Mobile Number not valid"
            ]
        },
        lazy: true,
        CDN_IMG_URL: process.env.CDN_IMG_URL
    }),
    computed: {
        error() {
            return this.$store.state.authenticate.error
        },
        confirmPasswordRule() {
            return this.checkFun()
        },
        version() {
            return this.$store.state.profile.appversion
        },
        ...mapState({
            getWhatsappData: (state) => state.user.whatsappData
        })
        // loginCheck() {
        //   return this.$store.state.profile.loggedIn
        // }
    },
    async created() {
        await this.$store.dispatch("user/getconfigs")
        this.$store.dispatch("profile/getDeploymentVersion")
        if (this.version.projectCode === "bd-new") {
            this.confirmForm.countryCode = "880"
            this.form.countryCode = "880"
            this.BDcheck = true
        } else {
            this.confirmForm.countryCode = "91"
            this.form.countryCode = "91"
        }
    },
    async mounted() {
        if (this.$auth && this.$auth.loggedIn) {
            await this.$store.dispatch("user/logout")
        }
        await this.$store.dispatch("profile/getProfile")
        if (this.loginCheck) {
            this.$router.push("/")
        }
    },
    methods: {
        countDownTimer() {
            if (this.countDown > 0) {
                this.timerCheck = true
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            } else {
                this.timerCheck = false
            }
        },
        onSelect(data) {
            this.form.countryCode = data.toString()
        },
        showSnackbar({ content, color }) {
            this.$store.commit("snackbar/open", {
                text: content,
                color
            })
        },
        checkFun() {
            if (
                this.confirmForm.newPassword ===
                this.confirmForm.confirmPassword
            ) {
                if (
                    this.version &&
                    this.version.projectCode &&
                    this.version.projectCode !== "bd"
                ) {
                    const strongPasswordPattern =
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/
                    if (
                        this.confirmForm.confirmPassword.length >= 6 &&
                        !strongPasswordPattern.test(
                            this.confirmForm.confirmPassword
                        )
                    ) {
                        this.valid = false
                        return false
                    } else {
                        this.valid = true
                        return true
                    }
                }
            } else {
                this.valid = false
                return "Password and Confirm Password must match"
            }
        },
        async forgotPassword() {
            if (this.$refs.form.validate()) {
                // this.form.userName = this.form.userName.toLowerCase()
                // if (this.version.projectCode === 'bd') {
                //   this.form.userName = this.form.mobileNo + '@fb.club'
                //   this.confirmForm.userName = this.form.userName
                // } else {
                //   this.confirmForm.userName = this.form.userName
                // }
                this.confirmForm.userName = this.form.userName
                this.form.countryCode = this.confirmForm.countryCode
                this.loading = true

                this.form.countryCode =
                    this.form.countryCode.split("")[0] === "+"
                        ? this.form.countryCode
                        : "+" + this.form.countryCode
                const forgotPasswordResult = await this.$store.dispatch(
                    "authenticate/forgotPassword",
                    this.form
                )
                this.loading = false
                if (!forgotPasswordResult) {
                    this.showSnackbar({
                        content: "Please try again",
                        color: "error"
                    })
                    this.$store.commit("authenticate/set_error", null)
                } else if (
                    forgotPasswordResult.data &&
                    forgotPasswordResult.data.status &&
                    forgotPasswordResult.data.status === 200
                ) {
                    this.step = "confirmCode"
                    // this.confirmForm.mobileNo = this.form.countryCode + this.form.mobileNo
                    this.showSnackbar({
                        content: forgotPasswordResult.data.data
                            ? forgotPasswordResult.data.data
                            : `Code sent to ${this.confirmForm.mobileNo} `,
                        color: "success"
                    })
                } else if (
                    forgotPasswordResult.data &&
                    forgotPasswordResult.data.error
                ) {
                    // this.showSnackbar({
                    //   content:
                    //     forgotPasswordResult.data.error.message || 'Please try again',
                    //   color: 'error'
                    // })
                    // this.$store.commit('authenticate/set_error', null)

                    for (const x in forgotPasswordResult.data.error) {
                        this.showSnackbar({
                            content:
                                forgotPasswordResult.data.error[x] ||
                                "Please try again",
                            color: "error"
                        })
                        this.$store.commit("authenticate/set_error", null)
                    }
                } else {
                    this.showSnackbar({
                        content: "Please try again",
                        color: "error"
                    })
                    this.$store.commit("authenticate/set_error", null)
                }
            }
        },
        async forgotPassword1() {
            if (this.$refs.form.validate()) {
                // this.form.userName = this.form.userName.toLowerCase()
                if (this.version.projectCode === "bd") {
                    this.form.userName = this.form.mobileNo + "@fb.club"
                    this.confirmForm.userName = this.form.userName
                } else {
                    this.confirmForm.userName = this.form.userName
                }
                this.loading = true

                this.form.countryCode =
                    this.form.countryCode.split("")[0] === "+"
                        ? this.form.countryCode
                        : "+" + this.form.countryCode
                const forgotPasswordResult = await this.$store.dispatch(
                    "authenticate/forgotPassword",
                    this.form
                )
                this.loading = false
                // if (this.error && this.error.message) {
                //   this.showSnackbar({ content: this.error.message, color: 'error' })
                //   this.$store.commit('authenticate/set_error', null)
                //   return
                // }
                // this.confirmForm.countryCode = this.form.countryCode
                // this.showSnackbar({
                //   content: `Code sent to ${this.confirmForm.mobileNo}.`,
                //   color: 'success'
                // })
                if (!forgotPasswordResult) {
                    this.showSnackbar({
                        content: "Please try again",
                        color: "error"
                    })
                    this.$store.commit("authenticate/set_error", null)
                } else if (
                    forgotPasswordResult.data &&
                    forgotPasswordResult.data.status &&
                    forgotPasswordResult.data.status === 200
                ) {
                    this.step = "confirmCode"

                    this.confirmForm.mobileNo =
                        this.form.countryCode + this.form.mobileNo
                    if (this.verifySms) {
                        this.confirmForm.code = ""
                    } else {
                        this.confirmForm.code = this.verifyStandardOTP
                    }
                    this.showSnackbar({
                        content: forgotPasswordResult.data.data
                            ? forgotPasswordResult.data.data
                            : `Code sent to ${this.confirmForm.mobileNo} `,
                        color: "success"
                    })
                } else if (
                    forgotPasswordResult.data &&
                    forgotPasswordResult.data.error
                ) {
                    for (const x in forgotPasswordResult.data.error) {
                        this.showSnackbar({
                            content:
                                forgotPasswordResult.data.error[x] ||
                                "Please try again",
                            color: "error"
                        })
                        this.$store.commit("authenticate/set_error", null)
                    }
                } else {
                    this.showSnackbar({
                        content: "Please try again",
                        color: "error"
                    })
                    this.$store.commit("authenticate/set_error", null)
                }
            }
        },
        isPasswordStrong() {
            if (
                this.version &&
                this.version.projectCode &&
                this.version.projectCode !== "bd"
            ) {
                const strongPasswordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/
                if (
                    this.confirmForm.newPassword.length >= 6 &&
                    !strongPasswordPattern.test(this.confirmForm.newPassword)
                ) {
                    this.isPasswordStrongFlag = false
                    this.valid = false
                } else {
                    this.isPasswordStrongFlag = true
                    this.valid = true
                }
            }
        },
        async changePassword() {
            if (this.verifySms) {
                this.$refs.confirmForgotForm.validate()
                if (!this.$refs.confirmForgotForm.validate()) {
                    return
                }
            } else {
                this.confirmForm.code = this.verifyStandardOTP
            }
            try {
                this.loading = true
                this.confirmForm.email = this.form.userName
                this.confirmForm.countryCode = this.form.countryCode
                const changePassword = await this.$store.dispatch(
                    "authenticate/resetPassword",
                    this.confirmForm
                )
                this.loading = false
                if (!changePassword) {
                    this.showSnackbar({
                        content: "Please try again",
                        color: "error"
                    })
                    this.$store.commit("authenticate/set_error", null)
                } else if (
                    changePassword &&
                    changePassword.data &&
                    changePassword.data.value
                ) {
                    this.showSnackbar({
                        content: "Password Changed Successfully",
                        color: "success"
                    })
                    this.$router.push("/login")
                } else if (
                    changePassword &&
                    changePassword.data &&
                    changePassword.data.value === false &&
                    changePassword.data.data
                ) {
                    this.showSnackbar({
                        content: changePassword.data.data,
                        color: "error"
                    })
                } else {
                    this.showSnackbar({
                        content: "Please try again",
                        color: "error"
                    })
                    this.$store.commit("authenticate/set_error", null)
                }
                // this.loading = false
                // if (this.error && this.error.message) {
                //   this.showSnackbar({ content: this.error.message, color: 'error' })
                //   this.$store.commit('authenticate/set_error', null)
                //   return
                // }
                // this.showSnackbar({
                //   content: 'Password Changed Successfully',
                //   color: 'success'
                // })
                // this.$router.push('/login')
            } catch (error) {
                this.loading = false
            }
        },
        async resendCode() {
            this.countDown = constants.resendcodeSec
            this.countDownTimer()
            const valueChanged = await this.$store.dispatch(
                "authenticate/resendCodeForOtp",
                {
                    mobileNo:
                        "+" +
                        this.confirmForm.countryCode +
                        this.confirmForm.userName
                }
            )
            if (this.error && this.error.message) {
                this.showSnackbar({
                    content: this.error.message,
                    color: "error"
                })
                this.$store.commit("authenticate/set_error", null)
                return
            }
            if (valueChanged.data.NoSmsErr && valueChanged.data.NoEmailErr) {
                this.showSnackbar({
                    // content: `Code resent to ${this.confirmForm.mobileNo}. & ${this.confirmForm.userName}`,
                    // content: `Code resent to ${this.confirmForm.mobileNo}`,
                    content: `OTP has been sent to registered Mobile Number!!!`,
                    color: "success"
                })
            } else {
                this.smsNotValid = "Failed to send OTP on mobile no."
                // this.showSnackbar({
                //   content: `Code resent to ${this.confirmForm.userName}.`,
                //   color: 'success'
                // })
            }
            // }
            // this.showSnackbar({
            //   content: `Code resent to ${this.confirmForm.mobileNo}.`,
            //   color: 'success'
            // })
            // await this.forgotPassword()
            // if (this.error && this.error.message) {
            //   this.showSnackbar({ content: this.error.message, color: 'error' })
            //   this.$store.commit('authenticate/set_error', null)
            //   return
            // }
            // this.showSnackbar({
            //   content: `Code resent to ${this.confirmForm.mobileNo}.`,
            //   color: 'success'
            // })
        }
    }
}
</script>
<style lang="scss">
.timer {
    background-color: #f36c21;
    border-radius: 50px;
    padding: 4px 10px;
    font-size: 16px;
    font-weight: bold;
    i {
        font-size: 18px !important;
        position: relative !important;
        top: -2px;
    }
}
.line-height .v-text-field__slot label {
    line-height: 20px;
}
</style>
